var _ellipse, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAcademy = function SvgAcademy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.344,
    cy: 46.336,
    fill: "#6C9BF1",
    rx: 21.711,
    ry: 13.027,
    transform: "rotate(9.217 32.344 46.336)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    d: "m14 23 42.861 6.955-3.303 20.36-42.862-6.955z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    d: "M35.069 11.547c1.822-.595 4.547-.153 6.087.988L67.648 32.15c1.54 1.14 1.312 2.547-.51 3.141L35.803 45.523c-1.822.595-4.547.152-6.087-.988L3.224 24.92c-1.54-1.14-1.312-2.547.51-3.142z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m35 27 24.382 8.413a4 4 0 0 1 2.696 3.781v13.212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M62 46v8"
  })));
};
export default SvgAcademy;